{
	"android": {
		"versionCode": 130,
		"versionName": "1.0"
	}
}
